import styled from 'styled-components';
import {dFlex, dFlexCenter, mobileMedia} from '../../../../globalVariables/GlobalVariables';
import {tokens} from '@tickchak/react-share/app';

export const frame = styled.button`
    ${dFlexCenter};
    flex-direction: column;
    height: 263px;
    max-width: 216px;
    padding: 0;
    border: 2px dashed var(--TA-color-border-brand, #8eedff);
    border-radius: 5px;
    background: transparent;
    cursor: pointer;
    box-shadow: 2px 4px 4px 0 rgba(211, 211, 211, 0.25);
    transition: background 150ms;
    &:hover { background: rgba(142, 237, 255, 0.06); }
    ${mobileMedia}{ display: none; }
`;

export const content = styled.div`
    ${dFlex};
    align-items: center;
    gap: var(--space-sm);
`;

export const label = styled.span`
    font-size: ${tokens.typography.fontSize.body};
    font-weight: ${tokens.typography.fontWeight.regular};
    line-height: 1.4;
    color: var(--TA-color-text-default);
`;

export const plusBadge = styled.span`
    ${dFlexCenter};
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: ${tokens.color.brand.main};
    color: var(--TA-color-text-default);
    flex-shrink: 0;
`;
